"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var HtmlHighlightText_1 = __importDefault(require("@components/Htmlizer/HtmlHighlightText"));
var linkUtils_1 = require("@utils/linkUtils");
var ExternalLink_1 = __importDefault(require("@components/ExternalLink"));
exports.default = (0, react_1.memo)(function Htmlizer(props) {
    var htmlParts = props.htmlParts, value = props.value, domain = props.domain;
    /** *
     * Empty react fragment cause an issue with google traduction plugin. That's why we use a span here.
     * */
    return (react_1.default.createElement("span", null, htmlParts
        ? htmlParts.map(function (part, index) {
            if (part.type === 'link' && (0, linkUtils_1.shouldBeRenderedAsLink)(part.value)) {
                return (react_1.default.createElement(ExternalLink_1.default, { href: part.value, domain: domain, key: index },
                    react_1.default.createElement(HtmlHighlightText_1.default, { value: part.value, partToHighlight: part.highlighted })));
            }
            return react_1.default.createElement(HtmlHighlightText_1.default, { key: index, value: part.value, partToHighlight: part.highlighted });
        })
        : value));
});
